import withSelectField from 'Lib/components/hoc/withSelectField';
import UnitSelect from './UnitSelect';

const UnitField = props => (
    <UnitSelect
        {...props}
        value={props.field.value}
        onChange={option => props.handleChange(option, props.form, props.field)}
        onBlur={() => props.handleBlur(props.form, props.field)}
    />
);

export default withSelectField(UnitField);
